import React from 'react';
import { displayName } from '../../../../App';
import MainGuidanceLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/Profile/AuthorizedViewers/Create';

function CreateAuthorizedViewers() {
  document.title = `${displayName}: Create Authorized Viewers`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default CreateAuthorizedViewers;
